import { useCallback, useMemo } from "react";
import Particles, { ParticlesProvider } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const particlesInit = async (engine) => {
  await loadSlim(engine);
};

export default function ParticleBackground() {
  const particlesLoaded = useCallback(async (container) => {
    console.log("Particles container loaded", container);
  }, []);

  const options = useMemo(
    () => ({
      fullScreen: {
        enable: true,
        zIndex: -1 // هتفرش تحت الكلام وفوق الخلفية الـ Gradient اللي إنت عاملها في الـ body
    },
    fpsLimit: 60,
    interactivity: {
        events: {
            onHover: {
                enable: true,
                mode: "grab",
            },
            onClick: {
                enable: true,
                mode: "push",
            },
        },
        modes: {
            grab: {
                distance: 140,
                links: { opacity: 0.5 }
            },
            push: { quantity: 5 }
        }
    },
    particles: {
        color: {
            value: "#fff", // لون النقاط البنفسجي المودرن
        },
        links: {
            color: "#fff", // لون خيوط الشبكة
            distance: 150,
            enable: true,
            opacity: 0.4, 
            width: 1.5,   
        },
        move: {
            direction: "none",
            enable: true,
            outModes: {
                default: "bounce",
            },
            random: false,
            speed: 1.5, 
            straight: false,
        },
        number: {
            density: {
                enable: true,
                area: 800,
            },
            value: 80, // عدد متوازن جداً للأداء
        },
        opacity: {
            value: 0.5,
        },
        shape: {
            type: "circle",
        },
        size: {
            value: { min: 2, max: 4 }, 
        },
    },
    detectRetina: true,}),
    [],
  );

  return (
    <ParticlesProvider init={particlesInit}>
      <Particles id="tsparticles" particlesLoaded={particlesLoaded} options={options} />
    </ParticlesProvider>
  );
}